import { AfterViewInit, Component, OnDestroy, OnInit, signal } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { CLIENT_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/client';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { DateUtil } from '../../../../../core/utils/date-util';
import { AuthStoreService } from '../../../../../state/modules/auth/auth-store.service';
import { ClientStoreService } from '../../../../../state/modules/client/client-store.service';
import { ClientService } from '../../../../../state/modules/client/services/client.service';
import { ScheduleService } from '../../../../../state/modules/schedule/services/schedule.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { ShiftDetailInfoComponent } from '../../../schedule/components/shift-detail-info/shift-detail-info.component';
import { MasterService } from '../../../../../state/master/services/master.service';
import { noRecordFound, START_UNSCHEDULED_SHIFT_FORM_CONTROLS } from './start-unscheduled-shift.constant';


@Component({
  standalone: false,
  selector: 'kt-start-unscheduled-shift',
  templateUrl: './start-unscheduled-shift.component.html',
  styleUrls: ['./start-unscheduled-shift.component.scss']
})
export class StartUnscheduledShiftComponent extends ModalBaseClass implements OnInit, AfterViewInit, OnDestroy {
  noRecordFound = noRecordFound;
  buttonConfig = BUTTON_CONFIG;
  data: any = null;
  formConstants = {
    client_id: {
      ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.client_id,
      templateOptions: {
        ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.client_id.templateOptions,
        label: MasterService.masterBusinessLabel.Client,
      }
    },
    location_id: {
      ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.location_id,
      templateOptions: {
        ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.location_id.templateOptions,
        label: MasterService.masterBusinessLabel.Location,
      }
    },
    area_id: {
      ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.area_id,
      templateOptions: {
        ...START_UNSCHEDULED_SHIFT_FORM_CONTROLS.area_id.templateOptions,
        label: MasterService.masterBusinessLabel.Area,
      }
    },
  };
  upcomingShifts = signal<any[]>([]);
  form = new UntypedFormGroup({});
  lookup: { client: BehaviorSubject<any[]>, location: BehaviorSubject<any[]>, area: BehaviorSubject<any[]> } = {
    client: new BehaviorSubject<any[]>([]),
    location: new BehaviorSubject<any[]>([]),
    area: new BehaviorSubject<any[]>([]),
  };
  allClient = [];
  allLocation = [];
  allArea = [];
  subscriptions: Subscription[] = [];
  user = null;
  loading = signal(false);
  findByUserId = null;
  cordiNator = {
    latitude : 0 ,
    logitude : 0
  }
  // selectedLocation 

  constructor(private service: NgbModal, private scheduleService: ScheduleService, private clientStoreService: ClientStoreService, public activeModal: NgbActiveModal, private authStoreService: AuthStoreService, private clientService: ClientService) {
    super(service);
  }

  ngOnInit() {
    this.setDistance()
    this.getUpcomingShift();
    this.subscriptions.push(this.clientStoreService.selectClientListByUser().subscribe(clients => this.lookup.client.next(clients || [])));
    this.subscriptions.push(this.authStoreService.selectUser().subscribe(user => this.user = user));
    this.clientService.getAssignedClientLookupByUserId(this.findByUserId).subscribe(data => {
      this.lookup.client.next(data.data.data.clients || []);
      this.allClient = data.data.data.clients || [];
    });
  }

  setDistance() {
      if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.cordiNator.latitude = position.coords.latitude || 0;
        this.cordiNator.logitude = position.coords.longitude || 0;
      }, () => {
      }, { enableHighAccuracy: false, timeout: 20000, maximumAge: 100000 });
    }
  }

  ngAfterViewInit() {
    this.subscriptions.push(this.form.get('client_id').valueChanges.subscribe(value => {
      if (value) {
        this.form.get('location_id').setValue(null);
        this.form.get('area_id').setValue(null);
        this.subscriptions.push(this.clientService.getAssignedLocationLookupWithDistanceByUserId({  client_id: this.form.get('client_id').value, current_latitude: (this.cordiNator.latitude).toString() , current_longitude: (this.cordiNator.logitude).toString()}).subscribe(res => {
          if (res && res.success) {
            this.lookup.location.next(res.data.data.location || []);
            this.allLocation = res.data.data.location || [];
          }
        }));
        // this.dispatchLocationAllList(value);
        this.form.get('location_id').enable();
      } else {
        this.form.get('location_id').setValue(null);
        this.form.get('area_id').setValue(null);
        this.form.get('location_id').disable();
        this.form.get('area_id').disable();
      }
    }));
    this.subscriptions.push(this.form.get('location_id').valueChanges.subscribe(value => {
      if (value) { 
        // this.selectedLocation = this.allLocation.find(val => val.location_id === value);
        this.form.get('area_id').setValue(null);
        this.dispatchAreaAllList(this.form.get('client_id').value, value);
        this.form.get('area_id').enable();
      } else {
        this.form.get('area_id').setValue(null);
        this.form.get('area_id').disable();
      }
    }));
  }

  getUpcomingShift() {
    const payload = {
      week_count: 0,
      week_start_date: DateUtil.dateToAssignSpecificTimeFrom(moment()),
    };

    if (this.findByUserId) {
      payload['userId'] = this.findByUserId;
    }

    this.scheduleService.getUpcomingShift(payload, this.findByUserId).subscribe(data => {
      if (data && data.success && data.data && data.data.data && data.data.data['upcoming-shifts'] && data.data.data['upcoming-shifts'].length) {
        this.upcomingShifts.set(data.data.data['upcoming-shifts'][0].shifts || []);
      } else {
        this.upcomingShifts.set([]);
      }
    })
  }

  viewDetailsClickHandler(shift) {
    this.openPopUp(ShiftDetailInfoComponent, { shiftAllInfo: shift, isModal: true }, { centered: true, size: 'lg', backdrop: 'static' });
  }

  saveClickHandler() {
    if (this.form.invalid) {
      setTimeout(() => {
        this.form.markAllAsTouched();
      });

      return;
    }
    // // Shift Restrication 
    // if (this.selectedLocation.location_is_enable_start_shift_restriction && navigator.geolocation) {
    //   const position = await this.getCurrentPosition();
    //   const distance = CommonUtil.distance(position['coords'].latitude, position['coords'].longitude, +this.selectedLocation.location_latitude,+this.selectedLocation.location_longitude, 'K');
    //   const distanceThreshold =  this.selectedLocation.location_fraud_distance_type === 'KILOMETER' ? this.selectedLocation.location_fraud_distance : this.selectedLocation.location_fraud_distance * 1000;
    //   if (distance > distanceThreshold) {
    //     this.toastr.error(ALERT_MESSAGES.SHIFT_RESTRICATION, '', { closeButton: true, timeOut: 3000 });
    //     return;
    //   }
    // }
    const formValue = this.form.value;
    const payload = {
      client: this.allClient.find(client => client.client_id === formValue.client_id),
      location: this.allLocation.find(loc => loc.location_id === formValue.location_id),
      area: this.allArea.find(area => area.area_id === formValue.area_id),
      ...formValue,
    };
    this.activeModal.close(payload);
  }

  // async getCurrentPosition() {
  //   return new Promise((resolve, reject) => {
  //     navigator.geolocation.getCurrentPosition(resolve, reject);
  //   });
  // }

  getLocationAllList(data) {
    if (data.success) {
      this.lookup.location.next(data.data.data.location || []);
      this.allLocation = data.data.data.location || [];
    }
  }

  getAreaAllList(data) {
    if (data.success) {
      this.lookup.area.next(data.data.data.areas || []);
      this.allArea = data.data.data.areas || [];
    }
  }

  /**
* Dispatch location list base table params
*/
  dispatchLocationAllList(clientId) {
    this.clientStoreService.dispatchClientCommon({
      callback: this.getLocationAllList.bind(this), data: { client_id: clientId, only_assigned_location: true },
      module: CLIENT_METHOD_CONSTANT.LOCATION,
      method: API_METHOD_CONSTANTS.GET_LOOKUP_BY_USER_ID,
    });
  }


  dispatchAreaAllList(clientId, locationId) {
    this.clientStoreService.dispatchClientCommon({
      callback: this.getAreaAllList.bind(this), data: { clientId, locationId },
      module: CLIENT_METHOD_CONSTANT.CLIENT_AREA,
      method: API_METHOD_CONSTANTS.GET_LOOKUP,
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub ? sub.unsubscribe() : null);
  }
}
